<template>
    <div>
        <div class="my_modal" v-bind:class="{show: (motorSelection!=null&&motorSelection.length>1) || (tractionSheaveSelection!=null&&tractionSheaveSelection.length>1)}" align="center">
            <div class="my_modal-dialog" style="min-width:800px">
                <div class="my_modal-content" style="max-height: calc(100vh - 30px)">
                    <div v-if="showInputSelectionModal_Motor==true">
                        <div class="my_modal-header" style="border-bottom:none">
                            <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">{{$t('3464')}} {{$t('1098')}}</div>
                            <div>
                                <span @click="closeModal(false)" class="fal fa-times fa-2x"></span>
                            </div>
                        </div>
                        <div class="my_modal-body" style="height:calc(100vw - 160px)">
                            <div style="margin-top: 10px;">
                                <table class="my_table_suspensionMeans ZAfont_family ZAfont_size">
                                    <thead style="height:60px">
                                        <tr style="display:flex; height:100%">
                                            <th style="flex:0 0 5%">ID</th>
                                            <th style="flex:0 0 5%">KID</th>
                                            <th style="flex:0 0 5%">TYP</th>
                                            <th style="flex:0 0 5%">{{$t('3453')}}</th>
                                            <th style="flex:0 0 5%">{{$t('3454')}}</th>
                                            <th style="flex:0 0 5%">Zusatz</th>
                                            <th style="flex:0 0 5%">U [V]</th>
                                            <th style="flex:0 0 5%">Nr [rpm]</th>
                                            <th style="flex:0 0 15%">{{$t('3067')}}</th>
                                            <th style="flex:0 0 10%">{{$t('298')}}</th>
                                            <th style="flex:0 0 5%">ZZ_MO</th>
                                            <th style="flex:0 0 5%">ZZ_MO2</th>
                                            <th style="flex:0 0 5%">ZZ_MS</th>
                                            <th style="flex:0 0 5%">ED1</th>
                                            <th style="flex:0 0 5%">ED2</th>
                                            <th style="flex:0 0 5%">PRAEF</th>
                                            <th style="flex:0 0 5%">PSGID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="motor in motorSelection" @click="rowClickMotor(motor, $event)" style="display:flex">
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.id!=null">{{motor.id}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.kid!=null">{{motor.kid}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.typ!=null">{{motor.typ}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.bg!=null">{{motor.bg}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.fe!=null">{{motor.fe}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.zusatz!=null">{{motor.zusatz}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.u1!=null">{{motor.u1}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.nr!=null">{{motor.nr}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 15%; text-align:left">
                                                <span v-if="motor.msart!=null">{{motor.msart}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="motor.mfbtyp!=null">{{motor.mfbtyp}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.zzmo!=null">{{motor.zzmo}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.zzmo2!=null">{{motor.zzmo2}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.zzms!=null">{{motor.zzms}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.eD1!=null">{{motor.eD1}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.eD2!=null">{{motor.eD2}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.praef!=null">{{motor.praef}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="motor.psgid!=null">{{motor.psgid}}</span>
                                                <span v-else>-</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-if="showInputSelectionModal_TractionSheave==true">
                        <div class="my_modal-header" style="border-bottom:none">
                            <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">{{$t('3464')}} {{$t('411')}}</div>
                            <div>
                                <span @click="closeModal(false)" class="fal fa-times fa-2x"></span>
                            </div>
                        </div>
                        <div class="my_modal-body" style="height:calc(100vw - 160px)">
                            <div style="margin-top: 10px;">
                                <table class="my_table_suspensionMeans ZAfont_family ZAfont_size">
                                    <thead style="height:60px">
                                        <tr style="display:flex; height:100%">
                                            <th style="flex:0 0 10%">ID</th>
                                            <th style="flex:0 0 5%">KID</th>
                                            <th style="flex:0 0 10%">{{$t('3038')}}</th>
                                            <th style="flex:0 0 10%">{{$t('1182')}}</th>
                                            <th style="flex:0 0 10%">{{$t('1123')}}</th>
                                            <th style="flex:0 0 10%">{{$t('91')}}</th>
                                            <th style="flex:0 0 10%">{{$t('92')}}</th>
                                            <th style="flex:0 0 10%">{{$t('1135')}}</th>
                                            <th style="flex:0 0 10%">{{$t('1067')}}</th>
                                            <th style="flex:0 0 10%">{{$t('294')}}</th>
                                            <th style="flex:0 0 10%">{{$t('165')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="tractionSheave in tractionSheaveSelection" @click="rowClickTractionSheave(tractionSheave, $event)" style="display:flex">
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.id!=null">{{tractionSheave.id}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 5%; text-align:left">
                                                <span v-if="tractionSheave.kid!=null">{{tractionSheave.kid}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.td!=null">{{tractionSheave.td}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.tb!=null">{{tractionSheave.tb}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.tarill!=null">{{tractionSheave.tarill}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.tauwi!=null">{{tractionSheave.tauwi}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.tauwi!=null">{{tractionSheave.taub}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.takwi!=null">{{tractionSheave.takwi}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.tcsd!=null">{{tractionSheave.tcsd}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.tdra!=null">{{tractionSheave.tdra}}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td style="flex:0 0 10%; text-align:left">
                                                <span v-if="tractionSheave.tdrz!=null">{{tractionSheave.tdrz}}</span>
                                                <span v-else>-</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="my_modal-footer" style="min-width:800px;justify-content:flex-end;">
                        <div>
                            <button @click="closeModal(false)" class="btn my_btn_standard" style="margin-right:5px">{{$t('3237')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import router from '../../../router';
    import { configurations } from '../../../store/configurations.module';
    import { tractionSheaveManual } from '../../../store/tractionSheaveManual.module'
    import InvalidityReasons from '../../dataValidation/InvalidityReasons';
    import LoaderIcon from '../../loader/LoaderIcon';
    import axios from 'axios';
    import Images from '../../configuration/Images';
    import TractionSheaveModal from '../../configuration/manualSteps/TractionSheaveModal';
    export default {
        name: 'InputSelectionModal',
        props: {
            version: '',
        },
        components: {
            InvalidityReasons,
            LoaderIcon,
            Images,
            TractionSheaveModal,
        },
        computed: {
            sapProfile: {
                get() {
                    return this.$store.state.configurations.sap;
                },
            },
            showInputSelectionModal_Motor: {
                get() {
                    return this.$store.state.inputsManual.showInputSelectionModal_Motor;
                }
            },
            motorSelection: {
                get() {
                    return this.$store.state.inputsManual.motordetailsSelection;
                }
            },
            showInputSelectionModal_TractionSheave: {
                get() {
                    return this.$store.state.inputsManual.showInputSelectionModal_TractionSheave;
                }
            },
            tractionSheaveSelection: {
                get() {
                    return this.$store.state.inputsManual.tractionSheavedetailsSelection;
                }
            },
        },

        created() {
        },

        methods: {
            ValueDecimalSeparator(value) {
                if (value != null) {
                    const localDecimal = { value: value, country: this.$store.state.configurations.language, }
                    return this.$get_decimalValueToLocaleString(localDecimal);
                }
                return value;
            },
            closeModal(value) {
                if (value == false) {
                    this.$store.dispatch('inputsManual/change_showInputSelectionModal_storeAction', { value: false});
                }
                else {
                    this.$store.dispatch('inputsManual/change_showInputSelectionModal_storeAction', { value: false });
                }
            },
            rowClickMotor(value, event) {
                if (value != null && value.hasOwnProperty('id') && value.id != null) {
                    this.$store.commit('inputsManual/change_motordetailsSelected_storeMutation', value.id);
                    this.$store.dispatch('inputsManual/change_showInputSelectionModal_storeAction', { value: false });
                    if (this.version == 'zlw') {
                        this.$store.dispatch('inputsManual/change_inputSelectionMotorTractionSheave_storeAction')
                    }
                }
            },
            rowClickTractionSheave(value, event) {
                if (value != null && value.hasOwnProperty('id') && value.id != null) {
                    this.$store.commit('inputsManual/change_tractionSheavedetailsSelected_storeMutation', value.id);
                    this.$store.dispatch('inputsManual/change_showInputSelectionModal_storeAction', { value: false });
                    if (this.version == 'zlw') {
                        this.$store.dispatch('inputsManual/change_inputSelectionMotorTractionSheave_storeAction')
                    }
                }
            },
        },
    }
</script>


<style>
    .my_inputCheckboxSelected {
        border: none !important;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

    .my_inputCheckbox2 {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox2 li {
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

    .my_inputCheckbox {
        border: 1px solid #ced2d8;
        list-style: none;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        padding-bottom: 0px;
        margin: 0;
    }

        .my_inputCheckbox li {
            display: inline-block;
            padding: 3px;
            /*margin-bottom: 3px;*/
        }

            .my_inputCheckbox li:nth-child(odd) {
                margin-right: 10px;
                width: calc(50% - 10px);
            }

            .my_inputCheckbox li:nth-child(even) {
                margin-left: 10px;
                width: calc(50% - 10px);
            }
</style>
